import { graphql } from '../../graphql';

export const getStaticFooterData = graphql(`
  query StaticFooterData {
    regions(cityId: 1) {
      id
      name
      latitude
      longitude
      slug
    }
    cities(filter: { scope: UNPOPULAR }, limit: 80) {
      id
      name
      slug
    }
  }
`);
